import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import type { GridRowSelectionModel } from '@mui/x-data-grid';

export const useGridSelection = (fieldName: string) => {
  const { watch, setValue } = useFormContext();
  const selectedRows = watch(fieldName) as number[];

  const handleSelectionChange = useCallback(
    (selectedRows: GridRowSelectionModel) => {
      setValue(fieldName, selectedRows);
    },
    [fieldName, setValue]
  );

  return {
    selectedRows,
    handleSelectionChange,
  };
};
